// import Image from "next/image";
// import { Smartphone, Apple } from "lucide-react";
import phoneImg from "../../images/KubermaxApp.png";
const DownloadApp = () => {
return (
<section style={{ background: "#fff", padding: "4.5rem 0" }}>
<div
style={{
display: "flex",
alignItems: "center",
justifyContent: "center",
maxWidth: 1400,
margin: "0 auto",
gap: 72,
flexWrap: "wrap",
        }}
>
{/* Left: Provided Image Only */}
<div
style={{
flex: "1 1 440px",
minWidth: 340,
maxWidth: 500,
display: "flex",
flexDirection: "column",
alignItems: "center",
          }}
>
<img
src={require("../../images/KubermaxApp.png")}
alt="Download Kubermax App"
style={{
width: "100%",
maxWidth: 420,
borderRadius: 20,
boxShadow: "0 8px 32px rgba(0,0,0,0.10)",
            }}
/>
</div>
{/* Right: App Cards */}
<div
style={{
flex: "1 1 600px",
minWidth: 380,
maxWidth: 700,
display: "flex",
flexDirection: "column",
gap: 48,
          }}
>
<div
style={{
background: "#f8fafd",
borderRadius: 24,
boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
padding: "3rem 2.5rem",
display: "flex",
flexDirection: "column",
alignItems: "center",
            }}
>
<div style={{ fontSize: 56, color: "#4FA0FF", marginBottom: 12 }}>
              📱
</div>
<div
style={{
fontWeight: 700,
fontSize: "2rem",
color: "#1D3557",
marginBottom: 14,
              }}
>
              Android App
</div>
<div
style={{
background: "#E5E5E5",
borderRadius: 10,
padding: "1rem 3rem",
color: "#1D3557",
fontWeight: 500,
fontSize: "1.25rem",
              }}
>
              Coming Soon
</div>
</div>
<div
style={{
background: "#f8fafd",
borderRadius: 24,
boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
padding: "3rem 2.5rem",
display: "flex",
flexDirection: "column",
alignItems: "center",
            }}
>
<div style={{ fontSize: 56, color: "#4FA0FF", marginBottom: 12 }}>
              🍏
</div>
<div
style={{
fontWeight: 700,
fontSize: "2rem",
color: "#1D3557",
marginBottom: 14,
              }}
>
              iOS App
</div>
<div
style={{
background: "#E5E5E5",
borderRadius: 10,
padding: "1rem 3rem",
color: "#1D3557",
fontWeight: 500,
fontSize: "1.25rem",
              }}
>
              Coming Soon
</div>
</div>
</div>
</div>
</section>
  );
};
export default DownloadApp;